module.exports = __webpack_public_path__ + "img/gift2-01-c1.a22b1a5b.png";